import React, { useRef, useState, useCallback,useEffect } from 'react';
import styled from '@emotion/styled'
import { useLocalization } from "gatsby-theme-i18n";
import LinkItem from "../LinkItem/LinkItem";
import * as breakpoint from '../../styles/breakpoints.module.scss';


const Submenu = ({isActive, onOpen, onClose, theme, linkItem}) => {

  const MenuElem = useRef()

  const [ isFocus, setFocus ] = useState(false);
  const { currentLocaleObj } = useLocalization();
  
  const handleMouseleave = useCallback(() => {
    setFocus(false);
  },[setFocus])

  useEffect(() => {
    if(MenuElem.current)
      MenuElem.current.addEventListener('mouseleave',handleMouseleave)

  });

  
  return (
  <MainMenuLinkItem className={`withSubmenu${isActive ? " menuOpened" :""} ${isFocus ? " focus" : ""}`} theme={theme} ref={MenuElem}>
    <MainMenuLink fade to={linkItem.to ? linkItem.to : null} href={linkItem.href ? linkItem.href : null} updatetime={linkItem.updatetime} theme={theme} >
      {linkItem.name}
    </MainMenuLink>
    <a className="arrow" href={`/${currentLocaleObj.prefix}/about/`} onClick={(e) => {
      e.preventDefault();
      setFocus(!isFocus);
      onOpen();
    }} tabIndex={0}>Arrow</a>
    <SubmenuElem>
      <SubmenuBackBtn onClick={(e) => {
        e.preventDefault();
        setFocus(false);
        onClose();
      }} />
      <ul>
        {linkItem.submenu.map((item,index) => {
          if(item.name !== "")
            return (
              <li key={`menu_${index}`}>
                <SubMenuLink fade to={item.to ? item.to : null} theme={theme} updatetime={item.updatetime}>
                  {item.name}
                </SubMenuLink>
              </li>
            )
          else
            return(<React.Fragment key={`menu_${index}`}></React.Fragment>);
        })}
      </ul>
    </SubmenuElem>
  </MainMenuLinkItem>);
}
 
export default Submenu;

const MainMenuLinkItem = styled.li`

  padding:0 16px;
  position:relative;
  display: flex;
  align-items: center;
  height:56px;

  &:first-of-type{
    margin-left:0;
  }
  &:last-of-type{
    margin-right:0;
  }

  border-radius: 6px 6px 0px 0px;
  transition: background .3s;
  overflow:hidden;
  padding-right:0px;

  @media only screen and (max-width: ${breakpoint.headerMax}){
    padding: 0;
  }

  
  .arrow{
    display:block;
    text-indent:-9999px;
    overflow:hidden;
    width:36px;
    height:56px;
    position:relative;
    margin-left:4px;

    &:after{
      content:' ';
      position:absolute;
      width:5px !important;
      height:5px !important;
      
    right:22px;
    top:24px;

      ${props => props.theme === "dark" ? `
        border-top:1px solid #F2F2F5;
        border-right:1px solid #F2F2F5;
      ` : `
        border-top:1px solid #4E4E50;
        border-right:1px solid #4E4E50;`}

      transform: rotate(135deg);
      transition: all .3s;
    }
  }
  
  &:hover, &.focus{
    background: #FCFCFF;
    overflow:visible;

    .arrow:after{
      top:26px;
      transform: rotate(-45deg);
      border-top:1px solid #4E4E50;
      border-right:1px solid #4E4E50;
    }
    > a{
      color:#4E4E50;
      &:after{width:calc(100% - 56px)}
    }
  }

  @media only screen and (max-width: ${breakpoint.headerMax}){
    margin:0;

    &:hover, &.focus{
      background: none;
      overflow:visible;
      > a{
        color:#F2F2F5;
      }
    }

    .arrow{
    background: #4E4E50;
    border-radius: 2px;
    width:24px;
    height:24px;
    position:absolute;
    z-index:2;
    top:50%;
    transform:translateY(-50%);
    right:0;
    margin-top:-4px;
    text-indent:-9999px;
    overflow:hidden;

    &:after{
      border-top:1px solid #F2F2F5 !important;
      border-right:1px solid #F2F2F5 !important;
      transform: rotate(45deg) translate(-50%,-50%) !important;
      top:50% !important;
      left:50% !important;
      margin-left:-4px !important;
      margin-top:1px !important;
    }
  }
  }
`

const MainMenuLink = styled(LinkItem)`
  font-size: 14px;
  line-height: 16px;
  display:inline-block;
  position:relative;
  text-decoration:none;
  font-weight:bold;
  ${props => props.theme === "dark" ? `color: #F2F2F5;` : `color: #4E4E50;`}

  @media only screen and (max-width: ${breakpoint.mdMax}) and (min-width: ${breakpoint.desktopHeaderMin}){
    html[lang=fr] &{
      max-width: 100px;
    }
  }

  &:after{
    content:' ';
    width:0;
    height:3px;
    border-radius: 2px;
    display:block;
    position:absolute;
    bottom: -20px;
    transition: width .3s;
    ${props => props.theme === "dark" ? `background: #CACACD;` : `background:#838385;`}
  }
  &:before{
    content:' ';
    width:6px;
    height:6px;
    background: #AEEA00;
    border-radius: 3px;
    display:none;
    top:-4px;
    right:-12px;
    position:absolute;
  }

  &.updated{
    & + .arrow{
      margin-left:14px;
    }
    &:before{
      display:block;
    }
  }

  &:not(.disabled):hover , &:not(.disabled):active, &:not(.disabled).active{
    color: #4E4E50;
  }

  &:not(.disabled):hover:after{
      width:100%;
  }
  &:not(.disabled):active:after{
    ${props => props.theme === "dark" ? `background:#F7F7FA;` : `background:#2C2C2E;`}

    width:100%;
  }

  &:not(.disabled).active:after{
    background:#D00F31;
    width:100%;
  }

  @media only screen and (max-width: ${breakpoint.headerMax}){
    height:auto;
    padding:16px;
    padding-right:44px;
    line-height:16px;
    margin-bottom:8px;
    position: relative;
    display: block;
    width:100%;

    color: #F2F2F5;

    &:before{
      top:12px;
      right:36px;
    }

    &:after{
      top:16px;
      width:3px !important;
      height:0px;
      left:0;
      transition: height .3s;
    }

    &:not(.disabled):hover:after,&:not(.disabled):active:after,&:not(.disabled).active:after{
      height:16px;
      width:3px;
    }

    &:after{
      background: #CACACD;
    }

    &.disabled{
      color:rgba(252, 252, 255, 0.4);
    }

    &:not(.disabled):hover , &:not(.disabled):active, &:not(.disabled).active{
      color: #FCFCFF;
    }

    &:not(.disabled):active:after{
      background:#F7F7FA;
    }
  }
`

const SubmenuElem = styled.div`
  width:280px;
  height:auto;
  position:absolute;
  top:100%;
  left:0;
  background: #FCFCFF;
  box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  border-radius: 0px 6px 12px 12px;
  opacity:0;
  transition: opacity .3s;
  padding:24px 16px;

  li{
    padding:0 !important;
    height: auto !important;
    display:none;
  }
  li:hover &, li:focus &, .focus &{
    display:block;
    opacity:1;
    li{
      display:block;
    }
  }

  @media only screen and (max-width: ${breakpoint.headerMax}){
    background:#2C2C2E;
    display:flex !important;
    width:272px;
    height:100vh;
    position: fixed;
    top: 0;
    left: 100vw;
    opacity:1;
    z-index: 10;
    
    padding: 0 32px;
    flex-direction: column;
    justify-content: center;

    .menuOpened &{
      transition: left .3s;

      li{
        display: block;
      }
    }

    .menuOpened li.withSubmenu.menuOpened &, .menuOpened li.withSubmenu.menuOpened:hover &, .menuOpened li.withSubmenu.menuOpened:active &{
      left:calc(100vw - 272px);
    }
  }
`

const SubMenuLink = styled(LinkItem)`
  font-size: 14px;
  line-height: 16px;
  display: inline-block;
  text-decoration:none;
  font-weight:bold;
  color:#2C2C2E;
  padding:16px;
  position:relative;

  &:before{
    border-radius: 2px;
    content:' ';
    position:absolute;
    left:0;
    top:16px;
    height:0;
    background:#838385;
    width: 3px;
    transition: height .3s;
  }

  &:after{
    content:' ';
    width:6px !important;
    height:6px !important;
    background: #AEEA00;
    border-radius: 3px;
    display:none;
    top:16px;
    right:4px;
    position:absolute;
  }
  &:hover:before{
    height:16px;
  }

  &.active:before{
    height:16px;
    background:#D00F31;
  }

  &.updated{
    &:after{
      display:block;
    }
  }

  @media only screen and (max-width: ${breakpoint.headerMax}){
    color:#F2F2F5;
    display:block;
    padding-right:48px;
    &:after{
      right:36px;
    }
  }
`


const SubmenuBackBtn = styled.a`
  display:none;
  position:absolute;
  width:56px;
  height:56px;
  &:before{
    content:' ';
    width:10px;
    height:10px;
    border-left:2px solid #FCFCFF;
    border-bottom:2px solid #FCFCFF;
    position:absolute;
    top:50%;
    left:50%;
    transform: rotate(45deg) translate(-50%,-50%);
    margin-top:5px;
  }

  @media only screen and (max-width: ${breakpoint.headerMax}){
    display:block;
    top:32px;
    left:16px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    top:26px;
  }
`
